import type { IconData } from '@stacksjs/iconify-core'

export const arrowDownRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 18H7a1 1 0 0 1 0-2h9V7a1 1 0 0 1 2 0v10a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M17 18a1 1 0 0 1-.707-.293l-10-10a1 1 0 0 1 1.414-1.414l10 10A1 1 0 0 1 17 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowDownRight
